/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable no-throw-literal */
import Axios from 'axios';
import uuidGenerator from 'uuid/v1';
import qs from 'querystring';
import store from './../store';
import * as apiHelper from './apiHelper';
import * as s2sActions from './../../s2sMigration/actions';
import * as bpServerConstants from './../../../server/helpers/bpConstants';
import bpClientLogger from './bpClientLogger';

const zipkinAxios = Axios.create();

function attachStandardHeaders(serviceHeaders) {
  let requestHeaders =
    serviceHeaders === undefined
      ? { 'Access-Control-Allow-Origin': '*' }
      : Object.assign({}, { 'Access-Control-Allow-Origin': '*' }, serviceHeaders);
  // add simulation header, if this is simulation session
  if (window.isSimulation) {
    requestHeaders[bpServerConstants.BP_SIMULATION_COOKIE] = window.simulationHeader;
  }

  // generate a correleation id
  requestHeaders[bpServerConstants.BP_CORRELATION_ID] = uuidGenerator();

  return requestHeaders;
}
function responseInterceptorSuccess(response) {
  store.dispatch({ type: 'REFRESH_LOGIN_SESSION', payload: '' });
  return response;
}

const responseInterceptorSuccessReturnData = resp => {
  // store.dispatch({ type: 'UPDATE_LAST_API_SESSION', payload: '' });
  store.dispatch({ type: 'REFRESH_LOGIN_SESSION', payload: '' });
  const requestURL = resp?.config?.url || resp?.request?.responseURL || '';
  if (requestURL?.toLowerCase()?.includes('/apps/ptb/api/token')) {
    const token = resp?.data?.access_token || '';
    if (token === '') {
      bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
      window.location.href = '/apps/ptb/logout';
      return;
    }
    store.dispatch({ type: 'SET_BP_USER_AUTH_DETAILS', payload: { bpUserToken: token } });
  }

  if (resp.headers && (resp.headers['content-type'] || '').toLowerCase().indexOf('application/pdf') !== -1) {
    return resp;
  }

  if (resp.headers && (resp.headers['content-type'] || '').toLowerCase().indexOf('text/csv') !== -1) {
    return resp;
  }

  if (resp.headers && (resp.headers['content-type'] || '').toLowerCase().indexOf('text/html') !== -1) {
    /* In case of 302 status code, here in Chrome and Edge browsers we are checking the condition with " responseURL in response.
     */
    // to making case-insensitive added resp.request.responseURL.toLowerCase()

    if (
      (resp.request &&
        resp.request.responseURL &&
        resp.request.responseURL.toLowerCase().indexOf('/apps/ptb/login') !== -1) ||
      resp.request.responseURL.toLowerCase().indexOf('/apps/ptb/_codexch') !== -1
    ) {
      // user is shown Re-login popup
      store.dispatch({ type: 'REFRESH_LOGIN_SESSION' });
      store.dispatch({ type: 'SESSION_EXPIRED_302' });
      store.dispatch(s2sActions?.showLogin(true));
      bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
    } /* In case of 302 status code, we are checking the condition with "Producer Toolbox" title text, this title text available in  2FA application as title tag in index.html page
            because in IE browser we are not able receive responseURL in response,and  we are checking the condition with <!doctype html> as well
           */
    // else if(resp.data && resp.data.toLowerCase().indexOf('producer toolbox two factor authentication') > -1)
    else if (resp.data && resp.data.toLowerCase().indexOf('<title>producer toolbox</title>') !== -1) {
      // user is shown Re-login popup
      // ** commented this code to fix the defect BPP-115017-refresh-issue-fix-for-access-control-page ** //
      // store.dispatch({ type: 'REFRESH_LOGIN_SESSION' });
      // store.dispatch({ type: 'SESSION_EXPIRED_302' });
      // store.dispatch(s2sActions?.showLogin(true));
    }
  }
  return resp.data;
};

function responseInterceptorError(err) {
  const enableSessionExpiredPopup = store.getState()?.homeReducers?.bpBrandFeatures?.enableSessionExpiredErrorPopup;
  if (err?.response?.data?.statusCode === 'TOKEN_EXPIRED' && err.config && !err.config.__isRetryRequest) {
    return apiHelper
      .getBPUserToken()
      .then(res => {
        err.config.__isRetryRequest = true;
        err.config.headers.Authorization = `Bearer ${res?.access_token}`;
        return Axios(err.config).then(res => {
          if (['application/pdf', 'text/csv'].includes((res?.headers['content-type'] || '').toLowerCase())) {
            return res;
          }
          return res.data;
        });
      })
      .catch(function(error) {
        throw error;
      });
  } else if (
    (err?.response?.status === 401 ||
      (err?.response?.status === 403 && err?.response?.data?.statusCode === 'FORBIDDEN_ACCESS')) &&
    err.config &&
    !err.config.__isRetryRequest
  ) {
    // Handle 401 Unauthorized error
    err.config.__isRetryRequest = true;
    // store.dispatch({ type: 'UPDATE_LAST_API_SESSION', payload: '' });
    setTimeout(() => {
      bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
      window.location.href = '/apps/ptb/logout';
    }, 2000);
    return;
  } else if (enableSessionExpiredPopup && err?.message?.toLowerCase() === 'network error') {
    // to check if 302 or CORS issue
    const url = err?.config?.url;
    const method = err?.config?.method;
    if (url && method) {
      Axios({...err?.config, maxRedirects: 0,})
        .then(res => {
          if (res?.statusCode == 302) {
            // in case 302 status
            // show session expired message to force user to go to login page
            bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
            store.dispatch(s2sActions?.showSessionExpiredMessage(true));
          }
        })
        .catch(e => {
          if (e && typeof e.response === 'undefined' && e.message?.toLowerCase() === 'network error') {
            // CORS issue: a CORS error makes e.response be undefined
            // show session expired message to force user to go to login page
            bpClientLogger?.remoteStore?.stopLogsBatchProcess?.();
            store.dispatch(s2sActions?.showSessionExpiredMessage(true));
          }
        });
    }
  }
  throw err?.response?.data?.error;
}

function isInternalRoute(route) {
  if (route && route.indexOf('/apps/ptb/') > -1) {
    return true;
  } else {
    return false;
  }
}

const requestInterceptor = config => {
  const state = store.getState();
  const { homeReducers = {} } = store.getState();
  const tokenAuthorization = homeReducers?.config?.data?.features?.tokenAuthorization;
  const token = state?.headerReducers?.bpUserToken || '';
  const selectedUserId = state?.headerReducers?.selectedUserId || '';
  const selectedTaxId = state?.headerReducers?.selectedTaxId || '';
  !state?.s2sReducers?.showLoginPopUP && store.dispatch(s2sActions?.resetIdleTimeout(true)); // to reset idletime of s2s
  if (tokenAuthorization) {
    // Using application/x-www-form-urlencoded format
    // https://www.npmjs.com/package/axios#browser
    let params = {};
    if (
      config.url === '/apps/ptb/api/token' &&
      selectedUserId &&
      (config?.isUserOrTINSelected || !window.location?.pathname?.includes('/apps/ptb/admin'))
    ) {
      params.bpUserId = selectedUserId;
    }
    if (
      config.url === '/apps/ptb/api/token' &&
      selectedTaxId &&
      (config?.isUserOrTINSelected || !window.location?.pathname?.includes('/apps/ptb/switchbroker'))
    ) {
      params.bpTaxId = selectedTaxId;
    }
    if (
      // window.location.pathname !== '/apps/ptb/' &&
      config.url === '/apps/ptb/api/token' &&
      (selectedUserId || selectedTaxId)
    ) {
      config.data = qs.stringify(params);
    }
    if (config.url !== '/apps/ptb/api/token' && token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
  }

  if (window.isSimulation && isInternalRoute(config.url))
    config.headers[bpServerConstants.BP_SIMULATION_COOKIE] = window.simulationHeader;

  return config;
};

zipkinAxios.interceptors.request.use(requestInterceptor, error => {
  Promise.reject(error);
});

// The standard response interceptor
// Lot of code which used to dependent on jQuery AJAX helper
zipkinAxios.interceptors.response.use(responseInterceptorSuccessReturnData, responseInterceptorError);

export default zipkinAxios; // to ensure the interceptors are attached

// export function get(url, data, serviceHeaders) {
//     let requestHeaders = attachStandardHeaders(serviceHeaders);
//     var request = Axios.create({
//         headers: requestHeaders
//     });
//     request.interceptors.response.use(responseInterceptorSuccess, responseInterceptorError);
//     const res = request.get(url, { params: data })
//         .then(response => {
//             return response.data
//         });
//     return res;
// }

// export function post(url, data, serviceHeaders) {
//     let requestHeaders = attachStandardHeaders(serviceHeaders);
//     var request = Axios.create({
//         headers: requestHeaders
//     });
//     request.interceptors.response.use(responseInterceptorSuccess, responseInterceptorError);
//     return request.post(url, { data: data }).then(data => { return data });
// }

// BPP-456 - Blank Commission Statements PDF
// We are using XMLHttpRequest instead of jQuery for service consumption to download files
// because responseType blob is not supported in jQuery
// responseType blob is needed to save files through browser
export function getFile(url, data, serviceHeaders) {
  let requestHeaders = attachStandardHeaders(serviceHeaders);
  const request = Axios.create({
    headers: requestHeaders,
  });

  request.interceptors.response.use(responseInterceptorSuccess);

  return request
    .get(url, { responseType: 'blob' })
    .then(response => {
      if (response.status === 200 || response.status === 204) return response.data;
      else return Promise.reject('Error in downloading pdf'); // TODO:this needs to be check.
      // Sending error based on previous logic in ajax.js
    })
    .catch(e => {
      // This is blob error;
      return BlobErrorReaderPromise(e.response.data);
    });
}

export function getFileViaPostData(url, data, serviceHeaders, pollCount = 0) {
  const axiosInstance = Axios.create({ headers: attachStandardHeaders(serviceHeaders) });
  axiosInstance.interceptors.response.use(responseInterceptorSuccessReturnData, responseInterceptorError);
  axiosInstance.interceptors.request.use(requestInterceptor, error => {
    Promise.reject(error);
  });

  return axiosInstance
    .post(url, data, { responseType: 'blob' })
    .then(response => {
      if (response?.status && (response.status === 200 || response.status === 204)) return response.data;
      if (response.size > 0) return response;
      if (pollCount)
        if (response.size === 0 && pollCount < 6) return response;
        else return Promise.reject('Error in downloading pdf');
    })
    .catch(e => {
      return BlobErrorReaderPromise(e?.response?.data);
    });
}

export function getFileV2(url, data, serviceHeaders, pollCount = 0) {
  const axiosInstance = Axios.create({ headers: attachStandardHeaders(serviceHeaders) });
  axiosInstance.interceptors.response.use(responseInterceptorSuccessReturnData, responseInterceptorError);
  axiosInstance.interceptors.request.use(requestInterceptor, error => {
    Promise.reject(error);
  });

  return axiosInstance
    .get(url, { responseType: 'blob' })
    .then(response => {
      if (response?.status && (response.status === 200 || response.status === 204)) return response?.data;
      if (response.size > 0) return response;
      if (pollCount)
        if (response.size === 0 && pollCount < 6) return response;
        else return Promise.reject('Error in downloading pdf'); // TODO:this needs to be check.
      // Sending error based on previous logic in ajax.js
    })
    .catch(e => {
      // This is blob error;
      return BlobErrorReaderPromise(e.response?.data);
    });
}

const BlobErrorReaderPromise = blob => {
  const tempReader = new FileReader();

  return new Promise((resolve, reject) => {
    tempReader.onload = () => {
      let parsed;
      try {
        parsed = JSON.parse(tempReader.result);
      } catch {
        parsed = tempReader.result;
      }
      reject(parsed);
    };

    tempReader.readAsText(blob);
  });
};